import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

/**
 * Mantido para links antigos /forgot-password/:token.
 * O fluxo atual de recuperação aponta para /reset-password?token=...
 */
export default function ForgotPassword() {
  const history = useHistory();
  const params = useParams();

  useEffect(() => {
    const { token } = params;
    if (token) {
      history.replace(`/reset-password?token=${encodeURIComponent(token)}`);
      return;
    }
    history.replace('/login');
  }, [history, params]);

  return null;
}
